import { formatDateTimeForBackend } from "../Functions";
import moment from "moment";
const isOldDateValidate = (
  selected_date,
  setOpenInvalidWarningDate,
  setInvalidWarningDateState
) => {
  // let today = moment().format("YYYY-MM-DD");
  // let d2 = moment(today).subtract(5, "month").format("YYYY-MM-DD");
  let d = new Date();
  let selectedDate = new Date(selected_date);
  if (selectedDate < d.setMonth(d.getMonth() - 6)) {
    setInvalidWarningDateState("Invoice date is more than 6 months old");
    setOpenInvalidWarningDate(true);
  } else if (selectedDate <= d.setDate(d.getDate() + 30)) {
    setInvalidWarningDateState("Invoice date is near to 6 months old");
    setOpenInvalidWarningDate(true);
    return;
  } else {
    setOpenInvalidWarningDate(false);
    return;
  }

  // if (selected_date < d2) {
  //  setInvalidWarningDateState("Invoice date is more than 6 months old")
  //   setOpenInvalidWarningDate(true);
  //   return;
  // }if (selected_date <= d2){
  //   setInvalidWarningDateState("Invoice date is near to 6 months old",() =>{
  //     setOpenInvalidWarningDate(true);
  //     return;
  //   });

  // } else {
  //   setOpenInvalidWarningDate(false);
  //   return;
  // }
};
export default isOldDateValidate;
